module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-section",
    attrs: {
      "id": "comp-app-form-btn"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "href": "/compAnnWrite.do"
    }
  }, [_c('i', {
    staticClass: "ico ico-pen-wt"
  }), _vm._v("\n    공고 등록\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a15e775"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/components/CompAppFormBtn.vue
// module id = 1412
// module chunks = 6